module.exports = __webpack_public_path__ + "static/media/posts-3.164e691f.jpg";